import React, { useState, useEffect } from "react";
import classes from "./PageTitle.module.scss";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { isEmptyObject } from "util/isEmptyObject";

const PageTitle = () => {
  const pageTitle = useSelector((state) => state.pageTitle);
  const { i18n } = useTranslation();
  const [direction, setDirection] = useState("rtl");

  useEffect(() => {
    if (!isEmptyObject(i18n)) {
      if (i18n.dir() === "ltr") {
        setDirection("ltr");
      } else {
        setDirection("rtl");
      }
    } else {
      setDirection("rtl");
    }
  }, [i18n.language]);

  return (
    <div
      className={
        direction === "rtl"
          ? classes.pageTitleContainer
          : classes.pageTitleContainerLtr
      }
    >
      <p>{pageTitle}</p>
    </div>
  );
};

export default PageTitle;
